// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aLgIV","buttons":"styles_buttons__3K16E"};